import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { formatDateTime } from 'core/components/common/converters';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { IncidentDetailPatient } from 'sections/ube/features/IncidentDetail/useIncidentDetailForUbe';
import { TagList } from 'core/components/JianDetail/PatientDetailInfo/common/TagList';

type Props = {
  /** 要請概要。 */
  requestSummary: IncidentDetailPatient['requestSummary'];
};

export const RequestSummaryView = ({ requestSummary }: Props) => {
  if (!requestSummary) {
    return (
      <BorderedContainer>
        <div className="flex flex-col gap-[24px]">
          <SectionTitle text="要請概要" />
          <p>データが存在しません</p>
        </div>
      </BorderedContainer>
    );
  }

  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="要請概要" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="発症時刻"
            content={formatDateTime(requestSummary.onsetAt)}
          />
          <InfoDisplay title="発症状況" content={requestSummary.onsetType} />
          <InfoDisplay
            title="事故等の状況"
            content={requestSummary.requestSummary}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="主訴" content={requestSummary.chiefComplaint} />
          <InfoDisplay
            title="接触時状況(現病)"
            content={requestSummary.siteArrivalSituationSummary}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="内服の状況"
            content={requestSummary.hasMedicationStatus ? '' : 'なし'}
          />
          <InfoDisplay
            title="服薬状況"
            content={
              <TagList
                tags={
                  requestSummary.medicationStatus?.map(
                    item => item.medicationName ?? ''
                  ) ?? []
                }
              />
            }
          />
          <InfoDisplay
            title="内服 自由記入欄"
            content={requestSummary.medicationStatusComment}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="既往の有無"
            content={requestSummary.isMedicalHistory ? '' : 'なし'}
          />
          <InfoDisplay
            title="既往等"
            content={<TagList tags={requestSummary.medicalHistory ?? []} />}
          />
          <InfoDisplay
            title="既往等 自由記入欄"
            content={requestSummary.medicalHistoryComment}
          />
          <InfoDisplay title="介護(級)" content={requestSummary.adlLevel} />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="アレルギーの有無"
            content={requestSummary.allergyPresence ? 'なし' : ''}
          />
          <InfoDisplay
            title="アレルギー"
            content={requestSummary.allergies ?? ''}
          />
          <InfoDisplay
            title="最終食事時刻"
            content={requestSummary.lastMealComment ?? ''}
          />
        </div>
      </div>
    </BorderedContainer>
  );
};
